module.exports = __webpack_public_path__ + "img/moca.93862e4b.png";